import React from 'react';
import { Divider, ListItemIcon, ListItemText, MenuItem, TextField } from '@material-ui/core';
import { SettingsInputSvideo } from '@material-ui/icons';
import { useFormContext } from '../FormContext';
import ConfigCard from './components/ConfigCard';
import ConfigContent from './components/ConfigContent';
import ConfigFieldControl from './components/ConfigFieldControl';
import ConfigHeader from './components/ConfigHeader';
export const FormConfigElement = () => {
    const formContext = useFormContext();
    const { formState, updateElement, elementPlugins } = formContext;
    const element = formState.selectedFormElement;
    return (React.createElement(ConfigCard, null,
        React.createElement(ConfigHeader, null, "Form Element"),
        React.createElement(ConfigContent, null,
            React.createElement(ConfigFieldControl, null,
                React.createElement(TextField, { fullWidth: true, select: true, size: 'small', variant: 'outlined', label: 'Element Type', placeholder: 'Select question type', value: element.type, onChange: event => {
                        const type = event.target.value;
                        const plugin = elementPlugins.find(p => p.type === type);
                        const newElement = (plugin === null || plugin === void 0 ? void 0 : plugin.init)
                            ? plugin.init(type, formContext, element)
                            : (() => {
                                // default form element initialization
                                const newElement = {
                                    type,
                                    title: element === null || element === void 0 ? void 0 : element.title,
                                    key: element === null || element === void 0 ? void 0 : element.key
                                };
                                if (!newElement.title) {
                                    newElement.title = 'Question';
                                    newElement.key = 'question';
                                }
                                return newElement;
                            })();
                        updateElement(newElement);
                    } }, elementPlugins.map((plugin, index) => plugin.type ? (React.createElement(MenuItem, { value: plugin.type, key: index },
                    React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                        React.createElement(ListItemIcon, null, plugin.icon || React.createElement(SettingsInputSvideo, null)),
                        React.createElement(ListItemText, { primary: plugin.name })))) : (plugin.divider && React.createElement(Divider, { key: index }))))),
            (() => {
                const plugin = elementPlugins.find(p => p.type === element.type);
                if (plugin === null || plugin === void 0 ? void 0 : plugin.configurator) {
                    return React.createElement(plugin.configurator, null);
                }
                return null;
            })())));
};
export default FormConfigElement;
//# sourceMappingURL=FormConfigElement.js.map